import React, { useState, useEffect } from 'react';
import useViewport from '../../../hooks/useViewport';
import { getMyDossiersAggregateStats } from '../../../services/dossierViewService';

const StatistiquesSidebar = () => {
    const { isMobile } = useViewport();
    const [stats, setStats] = useState({ vues: 0, visiteurs: 0, abonnes: 0 });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            setLoading(true);
            const data = await getMyDossiersAggregateStats();
            if (data) {
                setStats({
                    vues: data.totalViews,
                    visiteurs: data.uniqueViewers,
                    abonnes: data.followerCount,
                });
            }
            setLoading(false);
        };

        fetchStats();
    }, []);

    const statItems = [
        { value: stats.vues, label: 'Vues' },
        { value: stats.visiteurs, label: 'Visiteurs' },
        { value: stats.abonnes, label: 'Abonnés' },
    ];

    return (
        <div className={isMobile ? 'w-full' : 'w-80'}>
            <div className="bg-mcdm-primary-200 dark:bg-mcdm-third-400 border border-white dark:border-mcdm-third-400 rounded-lg p-4">
                <h2 className="text-mcdm-third-500 dark:text-mcdm-primary-100 font-platypi text-lg mb-2">
                    Vos statistiques
                </h2>

                <div className="grid grid-cols-3 gap-3">
                    {statItems.map(({ value, label }) => (
                        <div key={label} className="text-left">
                            {loading ? (
                                <div className="h-5 w-12 bg-gray-200 dark:bg-mcdm-third-300 rounded animate-pulse mb-1" />
                            ) : (
                                <div className="text-l font-bold text-mcdm-secondary-400 dark:text-mcdm-secondary-300">
                                    {value.toLocaleString()}
                                </div>
                            )}
                            <div className="text-xs text-mcdm-third-400 dark:text-mcdm-primary-200 mt-0 font-platypi">
                                {label}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default StatistiquesSidebar;
